import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { getStorySlug } from '../../../helpers/utils';
import { BQLink } from '../../atoms/bqlink';

import './section-video-page.m.css';
import { VideoCard } from '../../collection-templates/must-watch-video-list/video-card';
class SectionVideoPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      bid: null
    };
    this.playLiveTv = this.playLiveTv.bind(this);
  }

  playLiveTv(bid) {
    this.setState({ bid });
  }

  render() {
    const videos = get(this.props, ['data', 'videos'], []);

    return videos.length > 0 ? (
      <div className="container" styleName="video-wrapper">
        <div styleName="top-four-videos">
          {videos.slice(0, 4).map(video => (
            <BQLink
              key={video.id}
              href={`/video/${video.id}` || getStorySlug(video)}
              target="_blank"
              styleName="card-wrapper"
            >
              <VideoCard video={video} />
            </BQLink>
          ))}
        </div>
        <div styleName="rest-videos">
          {videos.slice(4, 24).map(video => (
            <BQLink
              key={video.id}
              href={`/video/${video.id}` || getStorySlug(video)}
              target="_blank"
              styleName="card-wrapper"
            >
              <VideoCard video={video} />
            </BQLink>
          ))}
        </div>
      </div>
    ) : null;
  }
}

SectionVideoPage.propTypes = {
  data: PropTypes.object,
  playerId: PropTypes.string,
  companyId: PropTypes.string
};

export { SectionVideoPage };
